import { columnasDeGrupo } from '@/core/services/tareasGrupoService'
import type { TareaRecurrenteInput } from '@/core/services/tareasRecurrentesService'
import type { TareaFormValues } from './tareaSchema'

/** Columnas de `tareas_recurrentes` que salen del formulario de tarea. */
export type ColumnasDelFormulario = Omit<
  TareaRecurrenteInput,
  'organizacion_id' | 'created_by' | 'workspace' | 'fecha_inicio' | 'activa'
>

/**
 * Traduce los valores del formulario de tarea a las columnas de una repetición. La usan el alta y
 * la edición. El grupo de clientes es excluyente con `cliente_id`. `dia_del_mes` solo se guarda en
 * el modo 'dia_fijo', y `dia_semana` solo con frecuencia 'semanal'.
 */
export const formularioARecurrente = (data: TareaFormValues): ColumnasDelFormulario => ({
  titulo: data.titulo,
  descripcion: data.descripcion ?? null,
  cliente_id: data.cliente_id || null,
  ...columnasDeGrupo(data.grupo_tipo, data.grupo_valor),
  asignado_a: data.asignado_a || null,
  prioridad: data.prioridad,
  frecuencia: data.rec_frecuencia,
  dia_modo: data.rec_dia_modo,
  dia_del_mes: data.rec_dia_modo === 'dia_fijo' ? data.rec_dia_del_mes : null,
  dia_semana: data.rec_frecuencia === 'semanal' ? data.rec_dia_semana : null,
  correr_a_habil: data.rec_correr_a_habil,
})
